import { useContext } from 'react';
import CookieBarContext from '../_context';

const useCookieBarContext = () => useContext(CookieBarContext);

export default useCookieBarContext;
